import React, { useState } from "react";
import axios from "axios";
import { useToast,InputGroup,Input,InputRightElement,Button } from "@chakra-ui/react";
import { NavLink, useNavigate } from "react-router-dom";
import Login from "./Login";
import { GoogleLogin } from "react-google-login";
import GoogleSocial from "./Google & facebook/GoogleSocial";
import FacebookSing from "./Google & facebook/FacebookSing";
import { useCookies } from "react-cookie";
import Loading from "./SubComponent/Loading";
import API_URL from "../Api/auction-api";
import ReactLoading from "react-loading";

// import {google} from 'googleapis'

const SignIn = ({ cond }) => {
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [Confirmpassword, setconfirmPassword] = useState("");
  const [move, setMove] = useState(true);
  const [existemail, setexistemail] = useState("");
  const [cookies, setCookie] = useCookies();
  const [load,setLoad]=useState(false)
  const [passView,setView]=useState(false)
  const [passView2,setView2]=useState(false)
  const [isloading, setLoading] = useState(false);


  const toast = useToast();

  const navigate = useNavigate();

  //  form prevent load
  function stopLoad(e) {
    e.preventDefault();
  }

  //  signin with google
  const handleLoginSuccess = (tokenId) => {
    // Send the token ID to your server for verification and user creation
    console.log("Login successful. Token ID:", tokenId);
  };

  const handleLoginFailure = (error) => {
    // Handle login failure or error
    console.error("Login failed:", error);
  };

  // function onSignIn(googleUser) {
  //   var profile = googleUser.getBasicProfile();
  //   console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
  //   console.log('Name: ' + profile.getName());
  //   console.log('Image URL: ' + profile.getImageUrl());
  //   console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
  // }

  //  password hide and view function
  const handleView=()=>{
    console.log(passView,"passview")
    setView(!passView)
  }
  const handleView2=()=>{
    setView2(!passView2)
  }

  // user sign in function 
  const handleRegister = async () => {
    const payload = {
      firstname,
      lastname,
      email,
      password,
    };

    // let existemail;
    setLoading(true)
    let res = await axios.post(`${API_URL}/exist`, { email });
    console.log(res);
    setexistemail(res.data);
    console.log(res.data);
    console.log(existemail, "existemail");

    if (res.data === "Email Not Exist") {
      try {
        if (firstname && lastname && email && password) {
          console.log(password.trim().split("").length,"leng")
          if(password.split("").length>5){
            
            if (password === Confirmpassword) {
              let res = await axios.post(`${API_URL}/register`, payload);
              
              console.log(res);
              console.log("user register done");
              // toast({
              //   title:"user Register sucussfully",
              //   position: "top-right",
              //   isClosable: true,
              //   status: 'success'
              // })
              const email = payload.email; // Replace with the actual email value
  
              setCookie("email", email);
              setCookie("password",password)
              setLoading(false)
              toast({
                title: "Account created.",
                description: " Your account successfully created",
                status: "success",
                duration: 9000,
                isClosable: true,
                position: "top-right",
              });
  
              navigate("/participate");
              // cond(true)
  
              // navigate("/home")
  
              // alert("done")
            } else {
              // alert("password not match")
              setLoading(false)
              toast({
                title: "Password Not Matched",
                description:"Check password and confirm password",
                position: "top-right",
                isClosable: true,
                status: "error",
              });
            }

          }else{
            setLoading(false)
            toast({
              title: "Password Need min 6 Characters.", 
              description:"password need minimum 6 character please provide 2 characters",
              status: "error",
              duration: 9000,
              isClosable: true,
              position: "top-right",
            });
            console.log("greater 6")

          }
          
        } else {
          setLoading(false)
          toast({
            title: "Fill all the Details",
            description:"Please provide all the required details",
            position: "top-right",
            isClosable: true,
            status: "error",
          });

          console.log("please fill all the details");
        }
      } catch (error) {
        setLoading(false)
        toast({
          title: "Account Not Created.",
          description: " Sorry Account Not Created please try after sometimes later.",
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });
        console.log("error adding");
        console.log(error);
      }
    } else {
      setLoading(false)
      toast({
        title: "Email is already exist",
        description:"This email Already Registerd use other email",
        position: "top-right",
        isClosable: true,
        status: "error",
      });
    }
  };

  return (
    <>
    {isloading ? <div
          style={{
            height: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "var(--background)",
          }}
        >
          <ReactLoading
            type={"bubbles"}
            color={"var(--background2)"}
            height={"10%"}
            width={"10%"}
          />
        </div> :  <div name="SingIn">
        <section class="h-screen">
          <div class="h-full">
            {/* <!-- Left column container with background--> */}
            <div class="g-6 flex h-full flex-wrap items-center justify-center lg:justify-between">
              <div class="shrink-1 mb-12 grow-0 basis-auto md:mb-0 md:w-9/12 md:shrink-0 lg:w-6/12 xl:w-6/12">
                <img
                  src="https://img.freepik.com/free-vector/mobile-login-concept-illustration_114360-83.jpg?w=740&t=st=1685599783~exp=1685600383~hmac=b9ea9f1d67dba1fabc68672ccbe59ce1bcca6a809a510ea9fc876298314781ae"
                  class="w-full"
                  alt="Sample image"
                />
              </div>

              {/* <!-- Right column container --> */}
              <div class="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">
                <h2 className="flex flex-col justify-center items-center text-3xl mb-5 font-bold font-serif">
                  Sign up
                </h2>
                <div class="flex flex-row items-center justify-center lg:justify-start">
                  <p class="mb-0 mr-4 text-lg">Sign up with</p>
                  {<GoogleSocial  applyLoading={setLoading}/>}
                  {/* {<FacebookSing/>} */}
                </div>
                <div class="my-4 flex items-center before:mt-0.5 before:flex-1 before:border-t before:border-neutral-300 after:mt-0.5 after:flex-1 after:border-t after:border-neutral-300">
                  <p class="mx-4 mb-0 text-center font-semibold dark:text-white">
                    Or
                  </p>
                </div>
                <form onSubmit={stopLoad}>
                  <div class="grid grid-cols-2 gap-4">
                    {/* F Name */}
                    <div class="relative mb-6">
                      <label
                        for="FirstName"
                        class="block text-sm font-medium text-gray-700"
                      >
                        First Name
                      </label>

                      <input
                        type="text"
                        id="FirstName"
                        name="first_name"
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                        class="mt-1 w-full p-2 rounded-md border border-gray-500 bg-white text-sm text-gray-700 shadow-sm"
                      />
                    </div>
                    <div class="relative mb-6">
                      {/* L Name */}
                      <label
                        for="LastName"
                        class="block text-sm font-medium text-gray-700"
                      >
                        Last Name
                      </label>

                      <input
                        type="text"
                        id="LastName"
                        name="last_name"
                        onChange={(e) => setLastName(e.target.value)}
                        required
                        class="mt-1 w-full p-2 rounded-md border border-gray-500 bg-white text-sm text-gray-700 shadow-sm"
                      />
                    </div>
                  </div>
                  {/* <!-- Email input --> */}
                  <div class="relative mb-6">
                    <label
                      for="Email"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Email address
                    </label>

                    <input
                      type="email"
                      id="Email"
                      name="email"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      class="mt-1 w-full rounded-md p-2 border border-gray-500 bg-white text-sm text-gray-700 shadow-sm"
                    />
                  </div>
                  {/* <!-- Password input --> */}
                  <div class="relative mb-6">
                    <label
                      for="Password"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Password
                    </label>
                    <InputGroup size='md'>
                    <input
                      type={passView?"text":"password"}
                      id="Password"
                      name="password"
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      class="mt-1 w-full rounded-md p-2 border border-gray-500 bg-white text-sm text-gray-700 shadow-sm"
                    />
                    <InputRightElement width='4.5rem'>
                      <Button background="none" h="15px" mt="8px" _hover={{background:"none"}} onClick={handleView}>
                      { passView ?<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.604 2.562l-3.346 3.137c-1.27-.428-2.686-.699-4.243-.699-7.569 0-12.015 6.551-12.015 6.551s1.928 2.951 5.146 5.138l-2.911 2.909 1.414 1.414 17.37-17.035-1.415-1.415zm-6.016 5.779c-3.288-1.453-6.681 1.908-5.265 5.206l-1.726 1.707c-1.814-1.16-3.225-2.65-4.06-3.66 1.493-1.648 4.817-4.594 9.478-4.594.927 0 1.796.119 2.61.315l-1.037 1.026zm-2.883 7.431l5.09-4.993c1.017 3.111-2.003 6.067-5.09 4.993zm13.295-4.221s-4.252 7.449-11.985 7.449c-1.379 0-2.662-.291-3.851-.737l1.614-1.583c.715.193 1.458.32 2.237.32 4.791 0 8.104-3.527 9.504-5.364-.729-.822-1.956-1.99-3.587-2.952l1.489-1.46c2.982 1.9 4.579 4.327 4.579 4.327z"/></svg>: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"/></svg>}
                      </Button>
                    </InputRightElement>

                    </InputGroup>

                    
                  </div>
                  {/* <!-- Password input --> */}
                  <div class="relative mb-6">
                    <label
                      for="PasswordConfirmation"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Password Confirmation
                    </label>
                    <InputGroup size='md'>
                    <input
                      type={passView2 ?"text": "password"}
                      id="PasswordConfirmation"
                      name="password_confirmation"
                      onChange={(e) => setconfirmPassword(e.target.value)}
                      required
                      class="mt-1 w-full rounded-md p-2 border border-gray-500 bg-white text-sm text-gray-700 shadow-sm"
                    />
                    <InputRightElement width='4.5rem'>
                      <Button background="none" h="15px" mt="8px" _hover={{background:"none"}} onClick={handleView2}>
                      { passView2 ?<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.604 2.562l-3.346 3.137c-1.27-.428-2.686-.699-4.243-.699-7.569 0-12.015 6.551-12.015 6.551s1.928 2.951 5.146 5.138l-2.911 2.909 1.414 1.414 17.37-17.035-1.415-1.415zm-6.016 5.779c-3.288-1.453-6.681 1.908-5.265 5.206l-1.726 1.707c-1.814-1.16-3.225-2.65-4.06-3.66 1.493-1.648 4.817-4.594 9.478-4.594.927 0 1.796.119 2.61.315l-1.037 1.026zm-2.883 7.431l5.09-4.993c1.017 3.111-2.003 6.067-5.09 4.993zm13.295-4.221s-4.252 7.449-11.985 7.449c-1.379 0-2.662-.291-3.851-.737l1.614-1.583c.715.193 1.458.32 2.237.32 4.791 0 8.104-3.527 9.504-5.364-.729-.822-1.956-1.99-3.587-2.952l1.489-1.46c2.982 1.9 4.579 4.327 4.579 4.327z"/></svg>: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"/></svg>}
                      </Button>
                    </InputRightElement>

                    </InputGroup>
                    

                  </div>
                  {/* <!-- Login button --> */}
                  <div class="text-center ">
                    <button
                      type="submit"
                      class="inline-block mb-2 rounded bg-primary px-16 pb-2.5 pt-3 text-sm font-medium uppercase leading-normal text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                      data-te-ripple-init
                      data-te-ripple-color="light"
                      onClick={handleRegister}
                    >
                      Sign up
                    </button>
                  </div>
                </form>
                <h3 className="mt-2">
                  Already have account{" "}
                  <a
                    class="text-danger underline text-sm font-bold ml-2 transition duration-150 ease-in-out cursor-pointer "
                    href="/login"
                  >
                    Login here
                  </a>
                </h3>
              </div>
            </div>
          </div>
        </section>
      </div>
}
    </>
  );
};

export default SignIn;
